export default __webpack_public_path__ + "static/media/sphere-2x.57f31c30.png";